export default __webpack_public_path__ + "music-headphones.png";